import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import ContactsImportStats from '../../../../Components/ContactsImportStats';
import EditCampaignForm from '../../../../Components/Forms/Client/Campaigns/EditCampaign';
import ModalsWrappedForm from '../../../../Components/Forms/ModalsWrappedForm';
import trans from '../../../../Translations/translation.service';
import { actions as allGroupsActions } from '../../../../Redux/Api/AllGroups';
import { actions as campaignsActions, types } from '../../../../Redux/Api/Campaigns';
import { actions as fileUploadActions } from '../../../../Redux/Ducks/FileUpload';
import { PRIVATE_PATHS } from '../../../config';
import { CAMPAIGNS_URL, FEMALE_CODE, JSON_HEADERS as headers } from '../../../../Constants';
import { EDIT_ACTIONS, CAMPAIGN_FORM as form } from '../../../../Components/Forms/Client/Campaigns/config';
import { catchApiItemErrors } from '../../../../Helpers';
import Typography from '@material-ui/core/Typography';
import {
  extractImportStats,
  getScanStatus,
  isScanPending,
  pollCampaignScan,
} from '../../../../Helpers/campaignScan';

class EditCampaign extends React.Component {
  state = {
    importStats: null,
    scanStatus: null,
    scanError: null,
    scanning: false,
    // true cuando el scan async/sync terminó OK (el poll pisa reduxRestResponse)
    scanSucceeded: false,
  };

  getCampaign = () => {
    const { id } = this.props.match.params;

    this.props.getCampaign(id);
  };

  getImportStats = () => {
    const { importStats, scanning, scanStatus, scanError } = this.state;
    const { response } = this.props;

    if (scanning || isScanPending(scanStatus)) {
      return (
        <Typography variant="body2">
          Procesando archivo de contactos…
        </Typography>
      );
    }

    if (scanError) {
      return (
        <Typography color="error" variant="body2">
          {scanError}
        </Typography>
      );
    }

    const stats = importStats
      || (response && response.data && extractImportStats(response.data));

    if (stats) {
      return (
        <ContactsImportStats {...stats} />
      );
    }

    return null;
  };

  loading = () => {
    const {
      isFetchingCampaign,
      isFetchingGroups,
      isUpdatingCampaign,
      isUploadingFile,
    } = this.props;
    const { scanning } = this.state;

    return isFetchingCampaign
      || isFetchingGroups
      || isUpdatingCampaign
      || isUploadingFile
      || scanning;
  };

  openSuccessModal = () => {
    const { file, fileUploadSuccess, success } = this.props;
    const { scanning, scanStatus, scanError, scanSucceeded } = this.state;

    if (scanning || isScanPending(scanStatus) || scanError) {
      return false;
    }

    const opOk = success || scanSucceeded;
    return opOk && (!file || fileUploadSuccess || scanSucceeded);
  };

  handleScanResponse = async (id, uploadResponse) => {
    const payload = (uploadResponse && uploadResponse.data) || uploadResponse || {};
    const status = getScanStatus(payload);
    const syncStats = extractImportStats(payload);

    if (syncStats && !isScanPending(status)) {
      this.setState({
        importStats: syncStats,
        scanStatus: status || 'done',
        scanning: false,
        scanError: null,
        scanSucceeded: true,
      });
      return;
    }

    if (!isScanPending(status)) {
      return;
    }

    this.setState({
      scanning: true,
      scanStatus: status,
      scanError: null,
      scanSucceeded: false,
    });
    try {
      const fetchFn = this.props.fetchCampaign || this.props.getCampaign;
      const campaign = await pollCampaignScan(fetchFn, id, {
        onProgress: (nextStatus) => {
          this.setState({ scanStatus: nextStatus });
        },
      });
      if (campaign.scan_status === 'failed') {
        this.setState({
          scanning: false,
          scanStatus: 'failed',
          scanError: campaign.scan_error || 'Error al procesar el archivo',
          scanSucceeded: false,
        });
        return;
      }
      this.setState({
        scanning: false,
        scanStatus: 'done',
        importStats: extractImportStats({ data: campaign }),
        scanError: null,
        scanSucceeded: true,
      });
    } catch (e) {
      this.setState({
        scanning: false,
        scanStatus: 'failed',
        scanError: e.message || 'Error al procesar el archivo',
        scanSucceeded: false,
      });
    }
  };

  parseGroups = () => (
    this.props.groups.map(({ id: value, name: text }) => ({
      text, value,
    }))
  );

  updateCampaign = ({ contacts_src_file, contacts, ...data }) => {
    const { id, file } = data;

    if (!file) {
      data.contacts = contacts;
    }

    return this.props.updateCampaign(data)
      .then(async res => {
        if (contacts_src_file) {
          await this.uploadContactsFile(id, contacts_src_file);
        }
      })
      .catch(
        catchApiItemErrors,
      );
  };

  uploadContactsFile = (id, contacts_src_file) => (
    this.props.uploadFile(
      `${CAMPAIGNS_URL}/${id}`,
      {
        contacts_src_file,
        contacts_src_file_name: contacts_src_file.name,
      },
      {
        headers,
      },
    ).then(res => this.handleScanResponse(id, res))
  );

  componentDidMount() {
    this.getCampaign();
    this.props.fetchAllGroups({}, { query: { client: true } });
    this.props.uploadFileReset();
  }

  render() {
    const { campaign, history } = this.props;
    const groups = this.parseGroups();
    const importStats = this.getImportStats();
    const subject = trans('resources.singular.campaign');

    return (
      <ModalsWrappedForm
        extraInfo={importStats}
        gender={FEMALE_CODE}
        history={history}
        loading={this.loading()}
        open={this.openSuccessModal()}
        path={PRIVATE_PATHS.clientCampaigns.path}
        subject={subject}
        successMessage="successOpSingF"
        type="edit"
      >
        {
          campaign &&
          <EditCampaignForm
            actions={EDIT_ACTIONS}
            data={{
              group_id: groups,
            }}
            history={history}
            onSubmit={this.updateCampaign}
            path={PRIVATE_PATHS.clientCampaigns.path}
          />
        }
      </ModalsWrappedForm>
    );
  }
}

const selector = formValueSelector(form);

const mapStateToProps = ({
  allGroups: {
    items,
    isFetching: isFetchingGroups,
  },
  campaigns: { isFetchingItem, isUpdating, item },
  fileUpload: { pending, response, success: fileUploadSuccess },
  reduxRestResponse: { body, success, type },
  ...state
}) => ({
  body,
  isFetchingGroups,
  response,
  campaign: item,
  file: selector(state, 'file'),
  fileUploadSuccess: !selector(state, 'contacts_src_file') || fileUploadSuccess,
  groups: items[1] ? items[1] : [],
  isFetchingCampaign: isFetchingItem,
  isUpdatingCampaign: isUpdating,
  isUploadingFile: pending,
  success: type === types.UPDATE_CAMPAIGN && success,
});
export default connect(
  mapStateToProps,
  {
    ...allGroupsActions,
    ...campaignsActions,
    ...fileUploadActions,
  }
)(EditCampaign);
